<div class="wraper">
  <div class="overlay" *ngIf="showSpinner">
    <div class="spinner-wrapper">
      <app-spinner></app-spinner>
    </div>
  </div>
  <div class="loaded-content" [class.blurred]="showSpinner">
    <p-table #reqlist [columns]="cols" [value]="requisitionExceptions" [lazy]="true" (onLazyLoad)="loadRequisitionExceptionsLazy($event)" [paginator]="true" styleClass="p-datatable-customers"
             [rows]="200" [totalRecords]="totalRecords" [loading]="loading">
      <ng-template pTemplate="caption">
        <div style="height: 30px !important; width: 100%">
          <span class="float-left">Resolved Exceptions</span>
          <div class="float-right">
            <input pInputText type="text" (keypress)="handleSearchKey($event, reqlist)" placeholder="search..." style="margin-right: 15px;" />
            <a (click)="reqlist.exportCSV()" class="text-white iconbutton" title="Export CSV"><i class="fal fa-file-csv" [ngClass]="{'fa-spin':loading}"></i></a>
            <a (click)="loadRequisitionExceptionsLazy(null)" class="text-white iconbutton" title="Refresh List"><i class="fa fa-refresh" [ngClass]="{'fa-spin':loading}"></i></a>
          </div>
        </div>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="Accession">Accession <p-sortIcon field="Accession"></p-sortIcon></th>
          <th pSortableColumn="PatientFullName">Patient <p-sortIcon field="PatientFullName"></p-sortIcon></th>
          <th pSortableColumn="LabPanelName">Test Type <p-sortIcon field="LabPanelName"></p-sortIcon></th>
          <th pSortableColumn="ClientName">Client <p-sortIcon field="ClientName"></p-sortIcon></th>
          <th pSortableColumn="PackageReceivedOn">Received Date <p-sortIcon field="PackageReceivedOn"></p-sortIcon></th>
          <th pSortableColumn="ResolvedBy">Resolved By <p-sortIcon field="ResolvedBy"></p-sortIcon></th>
          <th pSortableColumn="ResolvedDate">Resolved Date <p-sortIcon field="ResolvedDate"></p-sortIcon></th>
          <th pSortableColumn="RackSerialNumber">Rack (Location) <p-sortIcon field="RackSerialNumber"></p-sortIcon></th>
          <!-- <th pSortableColumn="RackLocationName">Location <p-sortIcon field="RackLocationName"></p-sortIcon></th> -->
          <th pSortableColumn="StatusText">Status <p-sortIcon field="StatusText"></p-sortIcon></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row>
        <tr> 
          <td>{{row.Accession}}</td>
          <td>{{row.PatientFullName}}</td>
          <td>{{row.LabPanelName}}</td>
          <td>{{row.ClientName}}</td>
          <td>{{row.PackageReceivedOn | date:'short'}}</td>
          <td>{{row.ResolvedBy}}</td>
          <td>{{row.ResolvedDate | date:'short'}}</td>
          <td>
            <a [routerLink]="['/resolve-rack-unload',row.RackSerialNumber]" >{{row.RackSerialNumber}} ({{row.RackLocationName}})</a>
          </td>
          <td><span class="p-tag p-tag-rounded"  [ngClass]="'p-tag-' + row.StatusValue">{{row.StatusText}}</span></td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
<p-toast>
</p-toast>
